import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { spacing } from '@retailer-platform/shared-components'
import { Input } from '../../../shared-styled-components/SharedStyledComponents'

const TimeSection = styled.div({
  marginTop: spacing.X12,
})

const Label = styled.div({
  paddingBottom: spacing.X12,
})

interface Props {
  value: string
  onChange: (time: string) => void
  label?: string
}

export const TimePickerField: FunctionComponent<React.PropsWithChildren<Props>> = ({
  value,
  onChange,
  label = 'Start Time:',
}) => (
  <TimeSection>
    <Label>{label}</Label>
    <Input
      type="time"
      value={value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
    />
  </TimeSection>
)
